<template>
    <div class="lineChart">
        <img v-if="noData" class="noDataImg mt28" src="../../assets/img/company/noData.svg" alt="">
        <section>
            <p v-if="isCompare || hasLine" class="homeComTitle hasLine">
                <span class="titleLine"></span>
                <span class="flex_1">{{ title }}</span>
            </p>
            <div v-else class="homeComTitle" :class="[ imgClass ]">
                <span class="flex_1">{{ title }}</span>
                <span v-if="controlTitle" class="fs14 co_666 font_n float_r"
                      @click="$emit('checkDetail')">{{ controlTitle }}</span>
            </div>

            <div class="content fs14" v-html="content"></div>
            <div class="chartBox" :id='chartId'></div>
        </section>
    </div>
</template>

<script>
import moment from 'moment'
import common from "@/util/common";
// import VConsole from 'vconsole';
// const vConsole = new VConsole();
// console.log(vConsole);
const echarts = require('echarts');
export default {
    name: "LineChart",
    props: {
        title: {
            type: String,
            default: '舆情健康指数趋势'
        },
        imgClass: {
            type: String,
            default: 'chartIcon'
        },
        renderData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        mainChief: Object,
        chartId: {
            type: String,
            default: "healthDate"
        },
        entity: {
            type: String,
            default: "金融业"
        },
        entityType: {
            type: String,
            default: "industry"
        },
        periodStr: {
            type: String,
            default: "日"
        },
        labelData: Array,
        controlTitle: String,
        isCompare: Boolean,
        hasLine: Boolean,
        formatxAxisDate: Boolean,
        articleCount:{
            type: Number,
            default: 0
        },
        subjectArticleCount:{
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            content: '',
            chart: null,
            noData: false,
        }
    },
    mounted() {
        this.renderFunc()
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    watch: {
        "entity": function () {
            this.renderFunc()
        }
    },
    methods: {
        renderFunc() {
            let {average, each, each1} = this.renderData;
            if ((average && average.length < 1) || (each && each.length < 1) || (each1 && each1.length < 1)) {
                this.noData = true
                return
            }
            this.noData = false;
            let data2 = [], length2 = 0, labelData = [common.convertEntityName(this.entity, this.entityType)],
                xAxis = each.map(item => this.formatxAxisDate ? moment(item.date).format("MM/DD") : item.date),
                data1 = each.length > 0 ? each.map(item => item.value) : [],
                length1 = data1.length,
                todayDate = xAxis[length1 - 1] || '';

            // 计算平均值时
            if (average) {
                // 需求改为计算7日均值时，全部按照最后一天的值，绘制一条直线
                // const baseAvg = average[average.length - 1].value;
                // average.forEach((e, index) => {
                //     average[index].value = baseAvg;
                // });
                data2 = average.length > 0 ? average.map(item => item.value) : [];
                length2 = data2.length;
                labelData.push('7日均值')
            }
            // 当数据非平均值时
            else if (each1) {
                data2 = each1.length > 0 ? each1.map(item => item.value) : [];
                length2 = data2.length;
            }

            let label = this.entityType == "industry" ? '7日' : '行业';
            let dataCha = data1[length1 - 1] - data2[length2 - 1];

            this.content = `${common.formatDateStr(this.periodStr)}，${common.convertEntityNameStr(this.entity, this.entityType)}的舆情报道总量为<b>${this.articleCount}篇</b>，其中<b>${this.subjectArticleCount}篇</b>为主体性报道，其余为提及性报道。${this.subjectArticleCount ? "基于主体性报道数据，": ""}综合测算得出${common.convertEntityName(this.entity, this.entityType)}的舆情健康指数为<span class="co_333 font_b">${data1[length1 - 1]}分</span>，
                            ${dataCha > 0 ? '高于' + label + '均值' : dataCha === 0 ? '与' + label + '均值持平' : '低于' + label + '均值'}`

            if(this.mainChief){
                this.content += `。对舆情健康指数产生影响的主要敏感事件为${common.covertHtmlLink(this.mainChief)}`
                if(this.entityType == "industry"){
                    let companies = this.mainChief.companies || [];
                    let entitLength = companies.length;
                    this.content+= entitLength > 1 ? `，该事件报道的主体为${companies[0].name}、${companies[1].name}${entitLength>2 ? '等。' :'。'}` : entitLength  ==1 ? `，该事件报道的主体为${companies[0].name}。`: `。`
                } else {
                    this.content += `。`
                }
            }else {
                this.content += `。`
            }
            // 如果传如 labelData 默认使用
            if (this.labelData)
                labelData = this.labelData;

            let colorData = ["#03399f", "#5F88CF"]
            if (this.isCompare) {
                colorData = ['#023A9F', '#F29E01'];

                //对比展示负面报道
                let mainChief = this.renderData.mainChief || null;
                let mainChief1 = this.renderData.mainChief1 || null;
                // console.log(mainChief, mainChief1);
                this.content = `<p>${labelData[0]}：在监测时段内，最高${Math.max.apply(Math, data1)}分，最低${Math.min.apply(Math, data1)}分`;
                if(mainChief){
                    this.content += `；对舆情健康指数产生影响的主要敏感事件为《<a href=${mainChief.uri} class="co_333" target="_blank"><b>${mainChief.title}</b></a>》等。</p>`
                }else {
                    this.content += `。</p>`
                }

                this.content += `<p>${labelData[1]}：在监测时段内，最高${Math.max.apply(Math, data2)}分，最低${Math.min.apply(Math, data2)}分`;
                if(mainChief1){
                    this.content += `；对舆情健康指数产生影响的主要敏感事件为《<a href=${mainChief1.uri} class="co_333" target="_blank"><b>${mainChief1.title}</b></a>》等。`
                }else {
                    this.content += `。</p>`

                }
            }

            // // test codes
            // data1[data1.length -1] = 100;
            // data2[data2.length -1] = 70;
            // console.log(data1LastOne, data2LastOne, data1Position, data2Position)
            // 调整曲线右边两个点的数字的位置
            let data1LastOne = data1[data1.length -1];
            let data2LastOne = data2[data2.length -1];
            let data1Position = [10, -2];
            let data2Position = [10, -2];
            let gap = data1LastOne - data2LastOne;
            if(gap >= 0 && gap <= 5) {
              data1Position = [10, -(7 - gap)];
              data2Position = [10, 5 - gap];
            } else if(gap <= 0 && gap >= -5) {
              data1Position = [10, 5 - gap];
              data2Position = [10, -(7 - gap)];
            }


            this.chart = echarts.init(document.getElementById(this.chartId));

            let option = {
                grid: {
                    top: '20%',
                    left: '3%',
                    right: '5%',
                    bottom: '2%',
                    containLabel: true,
                },
                legend: {
                    data: labelData,
                    right: 0,
                    itemWidth: 6,
                    icon: 'circle',
                    textStyle: {
                        color: colorData,
                        fontSize: 11,
                    }
                },
                xAxis: {
                    type: 'category',
                    data: xAxis,
                    axisLine: { //  改变x轴颜色
                        lineStyle: {
                            type: [5, 10],
                            dashOffset: 5,
                            color: '#C9C9CA',
                        }
                    },
                    axisLabel: { //  改变x轴字体颜色和大小
                        textStyle: {
                            color: "#000000",
                            fontSize: 11
                        },
                        interval: xAxis.length > 25 ? 5: (xAxis.length > 10 ? 3 : 0),
                        showMinLabel: true,
                        showMaxLabel: true,
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: false,
                    }
                },
                yAxis: {
                    type: 'value',
                    name: '健康指数(分)',
                    min: 0,
                    max: 100,
                    nameTextStyle: {
                        color: '#666666',
                        fontWeight: 'bold',
                        fontSize: 10
                    },
                    axisLine: { //  改变y轴颜色
                        show: false,
                    },
                    axisLabel: { //  改变y轴字体颜色和大小
                        //formatter: '{value} m³ ', //  给y轴添加单位
                        textStyle: {
                            color: "#000000",
                            fontSize: 10
                        },
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ['#C9C9CA'],
                            fontSize: 10,
                            width: 1,
                            type: 'dotted'
                        }
                    }
                },
                series: [{
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    name: labelData[0],
                    markPoint: {
                        symbol: "circle",
                        symbolSize: 6,
                        itemStyle: {
                            color: '#ffffff',
                            borderWidth: 1,
                        },
                        data: [
                            {
                                value: data1[length1 - 1],
                                label: {
                                    position: data1Position,
                                    color: colorData[0],
                                },
                                yAxis: data1[length1 - 1],
                                xAxis: todayDate,
                                itemStyle: {
                                    borderColor: colorData[0],
                                    shadowColor: colorData[0],
                                    shadowBlur: 1,
                                },
                            }
                        ]
                    },

                    data: data1,
                    itemStyle: {
                        normal: {
                            color: colorData[0],
                            borderColor: "#03399f",
                            borderWidth: 2
                        }
                    },
                    lineStyle: {
                        normal: {
                            width: 2,
                            color: colorData[0],
                        }
                    },
                }, {
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    markLine: {
                        symbol: "none",
                        label: {
                            show: false,
                        },
                        lineStyle: {
                            type: "dashed",
                            color: '#6087CF',
                            width: 1
                        },
                        data: [{
                            xAxis: todayDate
                        }]
                    }
                }, {
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    markPoint: {
                        symbol: "circle",
                        symbolSize: 6,
                        itemStyle: {
                            color: '#ffffff',
                            borderWidth: 1,
                        },
                        data: [

                            {
                                value: data2[length2 - 1],
                                label: {
                                    position: data2Position,
                                    color: colorData[1],
                                },
                                yAxis: data2[length2 - 1],
                                xAxis: todayDate,
                                itemStyle: {
                                    borderColor: colorData[1],
                                    shadowColor: colorData[1],
                                    shadowBlur: 1,
                                },
                            },
                        ]
                    },

                    data: data2,
                    name: labelData[1],
                    itemStyle: {
                        normal: {
                            color: colorData[1],
                            borderColor: "#03399f",
                            borderWidth: 2
                        }
                    },
                    lineStyle: {
                        normal: {
                            type: 'dashed',
                            width: 2,
                            color: colorData[1],
                        }
                    },
                }],
            };
            if (this.isCompare) {
                let colorData = ['#023A9F', '#6087CF', '#F29E01']
                option.legend.textStyle.color = colorData

                option.series.forEach((item, index) => {
                    if (item.itemStyle?.normal) {
                        item.itemStyle.normal.color = colorData[index]
                        item.lineStyle.normal.color = colorData[index]
                        item.lineStyle.normal.type = 'solid';
                    }

                })
            }
            this.chart.setOption(option);
        }
    }
}
</script>

<style lang="scss" scoped>
.lineChart {
    padding: 20px 16px;
    background-color: #FFFFFF;

    &.noLogin {
        padding: 0;
    }

    .content {
        line-height: 20px;
        margin: 12px auto 28px;
    }

    .chartBox {
        height: 300px;
    }
}


.noLoginBg {
    width: 100%;
    height: 429px;
    background-size: 100% 100%;
    position: relative;

    span {
        display: inline-block;
        height: 16px;
        position: absolute;
        top: 57px;

        &:nth-child(1) {
            width: 56px;
            left: 18px;
        }

        &:nth-child(2) {
            width: 70px;
            left: 87px;
        }

        &:nth-child(3) {
            width: 84px;
            left: 170px;
        }

        &:nth-child(4) {
            width: 84px;
            left: 267px;
        }
    }
}
</style>